import React from "react";
import Rbac from "../../../utils/Rbac";
import { Notification } from "../../../utils";

import JobsView from './components/JobsView'
import {createSubmenuItems} from "../../../utils/Helper";


  export const rbac = new Rbac({
  _rbac: {
    "admin": {
      write: true,
      editUser: true,
      delete: true,
      bookingInfo: true,
      mailSettings: true,
      groupList: true
    },
    "manager": {
      write: true,
      editUser: true,
      delete: false,
      bookingInfo: true,
      mailSettings: true,
      groupList: true
    },
    "booking-manager": {
      write: true,
      editUser: true,
      delete: false,
      bookingInfo: true,
      mailSettings: true,
      groupList: true
    },
    "manager-location": {
      write: false,
      editUser: true,
      delete: false,
      bookingInfo: true,
      mailSettings: true,
      groupList: true
    },
    "mediator": {
      write: false,
      editUser: false,
      delete: false,
      bookingInfo: true,
      mailSettings: true,
      groupList: false
    },
    "user": {
      write: false,
      editUser: false,
      delete: false,
      bookingInfo: false,
      mailSettings: false,
      groupList: false
    },
    "garage-staff": {
      write: false,
      editUser: false,
      delete: false,
      bookingInfo: true,
      mailSettings: true,
      groupList: false
    }
  }
});

export const FrontendLocationsPage = props => {


  const submenuItems = createSubmenuItems('frontendChanges');

  const showNotification = (msgType,msg) => {

    setTimeout( () => {
      if (msgType === 'success') {
        new Notification({
          message: msg,
          duration: 5000,
          type: 'success',
          closeable: true,
          icon: 'fi fi-check'
        });
      } else if (msgType === 'warning') {
        new Notification({
          message : msg,
          duration : 5000,
          type : 'warning',
          closeable : true,
          icon : 'fi fi-x'
        });
      }
    },200);
  };
  // mark main menu
  /*let mainMenu = document.getElementById('inb-main-menu');
  if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-users') && !props.status.mailSettings) {
      if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
      mainMenu.querySelector('.l-users').classList.add('active');
  }

  const showNotification = (msgType, itemId, action = 'saved') => {
    // little delay necessary to make notifications visible (render of background must be done before)
    const itemType = props.status.action == 'mailSettings' ? 'email_settings' : 'user';
    const idString = itemId === undefined || itemId == null ? '' : ' #'+itemId;

    setTimeout( () => {
      if (msgType === 'success') {
            new Notification({
              message : t(action + '_${a}',{a:t(itemType)},'capital')+idString,
              duration : 5000,
              type : 'success',
              closeable : true,
              icon : 'fi fi-check'
            });
          } else if (msgType === 'warning') {
            new Notification({
              message : t('request_error',null,'capital'),
              duration : 5000,
              type : 'warning',
              closeable : true,
              icon : 'fi fi-x'
            });
          }

    },200);    
  };

  const [users,setUsers] = useState([]);
  const [filters, setFilters] = useState({'find': props.status.action == 'staff' ? 'IsEmployee' : '!IsEmployee','sort': 'created','direction': 'desc'});
  const language = Biscuit.get('user.lang').replace('_','-');
  const _deleteUser = useSelector(state => state.users_data.deleteUser);
  const _user = useSelector(state => state.users_data.user);
  const _users = useSelector(state => state.users_data.users);

  // using state would cause re-render when changing the value of the searchbar
  const _queryState = {
    timeStamp: 0,
    value: ""
  }

  const getAvailableRoles = () => {

    let roles = ['admin','manager','booking-manager','mediator'];                             // these roles are always visible (admin is only selectable by other admins)

    if (props.status.action != 'staff') roles.push('user');                                   // user is only hidden in sidebar filter

    if (Biscuit.get('client.isVehicleOwner') === 'true') roles.push('manager-location');      // only vehicle owner have location managers

    if (Number(Biscuit.get('user.client_id')) == 28) roles.push('garage-staff');              // only client 28 is using this role for now

    return roles;
  }

  useEffect(() => {

    if (_deleteUser.success === "") {
      return;
    }

    if (_deleteUser.success === true) {

      showNotification('success',null,'removed');

      // update user list
      props.dispatch(userActions.getUsers({
        token: Biscuit.get('token'),
        filter: filters,
        headers: {
          'Accept-Language': language,
          'Content-Language': language
        }
      }));
    } else {
      console.log("Failed deleting user!");
    }
  },[_deleteUser]);

  useEffect(() => {
    if (_user.success === "") return;

    if (_user.success === true) {
      // update user in list
      for (var i=0;i<users.length;i++) {
        if (users[i].id == _user.data.id) {
          var clone = [...users];
          clone[i].active = _user.data.active;
          setUsers(clone);
          break;
        }
      }
    } else {
      console.log("Failed to request user!");
    }
  },[_user]);

  useEffect(() => {
    if (_users.success == "") return;

    if (_users.success === true) {
      setUsers([..._users.data]);
    } else {
      console.log("Failed to request users!");
    }
  },[_users]);

  const onSearchbarChanged = (ev) => {

    let query;
    if(typeof ev.target !== 'undefined') {
      query = ev.target.value.toLowerCase();
    } else {
      query = '';
    }
    const minLength = 3;

    if (query.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

      setTimeout(function () {

        var diff = Number(moment().format('x')) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value == query) {                  // no changes after the last 700 ms -> user finished input -> start request
                                                                        // -> this avoids additional requests during typing
          props.dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: {
                ...filters,
                'q': query
            }
          }));
          setFilters({
            ...filters,
            'q' : query
          });
        }
      },800);
    } else if (filters.q !== undefined) {
      // reset filter when query was active
      var clone = {...filters};
      delete clone.q;
      setFilters(clone);

      props.dispatch(userActions.getUsers({
        token: Biscuit.get('token'),
        filter: {
            ...clone
        }
      }));
    }

    _queryState.timeStamp = Number(moment().format('x'));
    _queryState.value = query;
  };

  const onFilterChanged = (filter) => {

    const _filter = {'find': props.status.action == 'staff' ? 'IsEmployee' : '!IsEmployee','sort': 'created','direction': 'desc'};
    let clone = {...filter};

    Object.assign(clone,_filter);
    setFilters(clone);

    props.dispatch(userActions.getUsers({
      token: Biscuit.get('token'),
      filter: clone,
      headers: {
        'Accept-Language': language,
        'Content-Language': language
      }
    }));
  };

  const onChangeSort = (ev) => {

    const el = ev.currentTarget;

    const sortKey = el.getAttribute('data-inb-val'),
        direction = el.getAttribute('data-inb-direction'),
        isOppositeElement = (direction === null && el.classList.contains('is-active')),
        newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

    if (sortKey) {
      let filter = {
        sort: sortKey,
        direction: direction
      };

      setFilters(Object.assign(filters, filter));
      props.dispatch(userActions.getUsers({
        token: Biscuit.get('token'),
        filter: filters,
        headers: {
          'Accept-Language': language,
          'Content-Language': language
        }
      }));

      const activeSortTab = $('.is-active');

      for (var tab=0;tab<activeSortTab.length;tab++) {
        activeSortTab[tab].classList.remove('is-active');
      }
      /!*
      _.each(activeSortTab, function(key,value){
        key.classList.remove('is-active');
      });
      *!/
      el.classList.add('is-active');
      el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
    }
  };

  const onDeleteUser = (user) => {

    // show warning
    if (confirm(t('really_remove'))) {
      props.dispatch(userActions.deleteUser({
          id: user.id,
          token: Biscuit.get('token')
      }));
    }
  };
  
  const onChangeUserActive = (e,user) => {

    props.dispatch(userActions.editUser({
      id: user.id,
      active: (e.target.checked ? 1 : 0),
      token: Biscuit.get('token')
    }));
  };

  const submenuItems = [
    {
      name: t('users',null,'capital'),
      link: 'users',
      data_inb_val: 'users',
      icon: 'fi fi-address-book',
      isActive: props.status.action == 'users' || props.status.action == 'edit' || props.status.action == 'add' ? true : false,
      isAccessible: isViewVisible('users','users')
    },{
      name: t('staff',null,'capital'),
      link: 'users/staff',
      data_inb_val: 'staff',
      icon: 'fi fi-torsos-all',
      isActive: props.status.action == 'staff' ? true : false,
      isAccessible: isViewVisible('staff','users')
    }
  ];

  let tabs =[{
    name: 'ID',
    smallWidth: 2,
    style: {minWidth:'90px'},
    extraClasses: 'medium-20-3',
    title: t('sort_by_${a}',{a:t('ID')},'capital'),
    canSort: true,
    sort: {
      direction: 'desc',
      data_inb_val: 'customer_nbr'
    }
  },{
    name: t('name',null,'capital'),
    smallWidth: 2,
    style: {minWidth:'90px'},
    extraClasses: 'medium-20-3',
    title: t('name',null,'capital'),
    canSort: true,
    sort: {
      direction: 'asc',
      data_inb_val: 'last_name'
    }
  },{
    name: t('username',null,'capital'),
    mediumWidth: 2,
    smallWidth: 2,
    style: {minWidth:'90px'},
    extraClasses: 'medium-20-3',
    title: t('sort_by_${a}',{a:t('username')},'capital'),
    canSort: true,
    sort: {
      direction: 'asc',
      data_inb_val: 'username'
    }
  }, {
    name: t('email'),
    smallWidth: 2,
    style: {minWidth:'90px'},
    extraClasses: 'medium-20-4',
    title: t('sort_by_${a}',{a:t('email')},'capital'),
    canSort: true,
    sort: {
      direction: 'asc',
      data_inb_val: 'email'
    }
  },{
    name: t('created_at',null,'capital'),
    smallWidth: 1,
    style: {minWidth:'90px'},
    extraClasses: 'medium-20-2',
    title: t('created_date',null,'capital'),
    canSort: true,
    sort: {
      direction: 'desc',
      data_inb_val: 'created'
    }
  }];

  if (props.status.action == 'staff') {
    tabs.push({
      name: t('role',null,'capital'),
      smallWidth: 1,
      style: {minWidth:'90px'},
      extraClasses: 'medium-20-3',
      title: t('role',null,'capital'),
      canSort: true,
      sort: {
        direction: 'desc',
        data_inb_val: 'role'
      }
    });
  }

  return (
    <>
      {!props.status.mailSettings &&
      <>
        <UserSidebar
          setSelectedFilter={onFilterChanged}
          activeSubmenu={props.status.action == 'staff' ? 'staff' : 'user'}
          getAvailableRoles={getAvailableRoles}
        />
        <div id="inb-c-main" className="columns">
          <InboomaSubmenu
            tabs={submenuItems}
            searchbar={true}
            searchbarPlaceholder={t('username') +' / ID / '+ t('e-mail')}
            searchbarHandler={onSearchbarChanged}
            />
          <SortNav
              tabs={tabs}
              handler={onChangeSort}
          />
          {props.status.users == 'finished' &&
            <div className="off-canvas-wrapper">
              <div id="inb-c-main-users" className="inb-c-listing off-canvas-content" data-off-canvas-content="" style={{paddingTop:'12px'}}>
                {typeof users.map == 'function' && users.map((user, index) => {
                  return (
                    <>
                      <div className={"inb-c-item inb-c-item--order row" + (user.active === true ? ' not-marked' : ' red-marked')} key={index}>
                        <div className="medium-20-3 small-2 column" title={t('kunden_nbr',null,'capital')} style={{minWidth:'90px'}}>
                          <span>{user.customer_nbr}</span>
                        </div>
                        <div className="medium-20-3 small-2 column" title={t('name',null,'capital')} style={{minWidth:'90px'}}>
                          <span>{user.first_name + ' ' + user.last_name}</span>
                        </div>
                        <div className="medium-20-3 small-2 column" title={t('username',null,'capital')} style={{minWidth:'90px'}}>
                          <span>{user.username}</span>
                        </div>
                        { props.status.action == 'staff' &&
                        <div className="medium-20-4 small-2 column inb-user--email" title={t('email',null,'capital')} style={{overflowWrap:'break-word',minWidth:'90px'}}>
                          {user.email}
                        </div>
                        }
                        { props.status.action != 'staff' &&
                        <>
                        <div className="medium-20-3 small-2 column inb-user--email" title={t('email',null,'capital')} style={{overflowWrap:'break-word',minWidth:'90px'}}>
                          {user.email}
                        </div>
                        <div className="medium-20-1 small-1 column" title={t('user_active',null,'capital')}>
                          <div className="switch tiny inb-form__controllClass">
                            <input id={"user_item_input_active_"+index} type="checkbox" className="user_item_input_active switch-input" checked={user.active} onChange={(e) => onChangeUserActive(e,user)} />
                            <label className="switch-paddle" htmlFor={"user_item_input_active_"+index}>
                              <span className="show-for-sr">Toggle content</span>
                            </label>
                          </div>
                        </div>
                        </>
                        }
                        <div className="medium-20-2 column" title={t('created',null,'capital')} style={{minWidth:'90px'}}>
                          <span>{moment(user.created).format('DD.MM.YYYY')}</span>
                        </div>
                        { props.status.action == 'staff' &&
                          <div className="medium-20-2 column" title={t('role',null,'capital')} style={{minWidth:'90px',overflowWrap:'break-word'}}>
                            {t('role_' + user.role)}
                          </div>
                        }
                        <div className="medium-offset-0 medium-20-2 column item-button-group right">
                          <div className="button-container right" style={{marginLeft:'5px'}}>
                            { rbac.hasPermission('delete') &&
                            <a
                              href="#"
                              className="inb-reservation__pdf2"
                              title={t('delete')}>
                              <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUser(user)}>
                                <div className="inb-fi-remove"></div>
                                </button>
                            </a>
                            }
                          </div>
                          <div className="button-container right">
                            { rbac.hasPermission('editUser') && 
                            <a
                              href={"/users/"+user.id+'?path=' + (props.status.action == 'staff' ? '/users/staff' : '/users')}
                              title={t('edit')}
                              data-inb-action-link="edit">
                              <button type="button" className="inb-round-btn hollow round float-left">
                                <div className="inb-fi-edit"></div>
                              </button>
                            </a>
                            }
                          </div>
                        </div>
                        { props.status.action != 'staff' &&
                          <div className="medium-offset-0 medium-20-2 column item-button-group right" style={{paddingRight:'5px',paddingLeft:'5px',minWidth:'45px'}}>
                            { user.active &&
                              <div className="button-container right" style={{marginLeft:'5px'}}>
                                <a
                                  href={"/orders/add?&user_id=" + user.id + "&skipFilter=1"}
                                  title={t('add_${a}',{a:t('order')})}>
                                  <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-page-add"></div>
                                  </button>
                                </a>
                              </div>
                            }
                            <div className="button-container right">
                              <a
                                href={"/orders?&user_id=" + user.id}
                                title={t('orders',null,'capital')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                  <div className="inb-fi-page"></div>
                                </button>
                              </a>
                            </div>
                          </div>
                        }
                        { props.status.action == 'staff' &&
                          <div className="medium-offset-0 medium-20-1 column item-button-group right" style={{paddingRight:'5px',paddingLeft:'5px',minWidth:'45px'}}>
                            <div className="button-container right" style={{marginLeft:'5px'}}>
                              <a
                                href={"/usersExtension/mailSettings?id=" + user.id + "&path=/users/staff"}
                                title={t('email_settings')}>
                                <button type="button" className="inb-round-btn hollow round float-left">
                                  <div className="inb-fi-mail"></div>
                                </button>
                              </a>
                            </div>
                          </div>
                        }
                      </div>
                    </>
                  )}
                )}
              </div>
            </div>
          }
        </div>
      </>
      }
      {((props.status.action == 'add' && props.status.user == 'add') || (props.status.action == 'edit' && props.status.user == 'finished')) &&
        <ItemView
          user={props.user}
          showNotification={showNotification}
          requestPath={props.status.returnPath}
          dispatch={props.dispatch}
          getAvailableRoles={getAvailableRoles}
        />
      }
      {props.status.action == 'mailSettings' && props.status.emailSettings == 'finished' && props.status.user == 'finished' &&
         <EmailSettingsView
           user={props.user}
           emailSettings={props.emailSettings}
           dispatch={props.dispatch}
           requestPath={props.status.requestPath}
           showNotification={showNotification}
           />
      }
    </>
  );*/
  return(
      <>
        {props.status.action == 'getJobs' && props.status.jobs == 'finished' &&
        <JobsView
            jobs={props.jobs}
            dispatch={props.dispatch}
            submenuItems={submenuItems}
            showNotification={showNotification}
        />
        }
      </>
  );
};